import CheckoutStatus from '../checkout/Status'
import CheckoutCreditPackages from '../checkout/CreditPackages'

const Checkout = () => {
  return (
    <>
      <CheckoutStatus />
      <CheckoutCreditPackages />
    </>
  )
}

export default Checkout
